import useFormatDate from 'hooks/useFormatDate'
import { FC } from 'react'

export const DateFormatted: FC<{ date?: string | null }> = ({ date: value }) => {
  const formatter = useFormatDate()

  return <>{formatter(value)}</>
}
